<template>
  <generic-view
    :title="$t('stages')"
    icon="walking"
    v-bind:show_plus="true"
    v-on:add="add"
  >
    <div
      class="ui error message"
      style="display: inline-block"
      v-if="stage_weighting_summation > 100"
    >
      <div class="header">
        {{ $t("limit overflow") }}
      </div>
      <p>
        {{ $t("weighting summation is above limit, check stages weighting") }}
      </p>
    </div>
    <div
      class="ui info message"
      style="display: inline-block"
      v-if="stage_weighting_summation < 100"
    >
      <div class="header">
        {{ $t("weighting incomplete") }}
      </div>
      <p>
        {{ $t("weighting summation is incomplete, check stages weighting") }}
      </p>
    </div>
    <div class="ui two column grid">
      <stage
        :stage="stage"
        :index="index"
        v-for="(stage, index) in stages"
        :key="index"
        @remove_stage="remove_stage"
      />
      <!-- <generic-view
        class="column"
        :title="stage.name + ' - ' + stage.weighting_percent + '%'"
        icon="shoe prints"
        v-for="(stage, index) in stages"
        :key="index"
        v-bind:show_plus="true"
        v-on:add="add_task(stage)"
        :header_buttons="header_buttons"
        :data-idx="index"
      >
        <div class="ui form">
          <div class="fields">
            <div class="ten wide field">
              <label for="">{{ $t("name") }}</label>
              <input type="text" name="" v-model="stages[index].name" />
            </div>
            <div class="six wide field">
              <label for="">{{ $t("weighting") }} (%)</label>              
              <input
                type="text"
                name=""
                v-model="stages[index].weighting_percent"
              />
            </div>
          </div>
        </div>
        <h4 class="ui dividing header">{{ $t("tasks") }}</h4>
        <div
          class="ui error message"
          style="display: inline-block"
          v-if="task_weighting_summation(stage) > 100"
        >
          <div class="header">
            {{ $t("limit overflow") }}
          </div>
          <p>
            {{
              $t("weighting summation is above limit, check tasks weighting")
            }}
          </p>
        </div>
        <div class="ui form">
          <div class="fields" v-for="(task, idx) in stage.tasks" :key="idx">
            <div class="ten wide field">
              <label for="" v-if="idx == 0">{{ $t("name") }}</label>
              <input
                type="text"
                name=""
                v-model="stages[index].tasks[idx].name"
              />
            </div>
            <div class="six wide field">
              <label for="" v-if="idx == 0">{{ $t("weighting") }} (%)</label>
              <input
                type="text"
                name=""
                v-model="stages[index].tasks[idx].weighting_percent"
              />
            </div>
          </div>
        </div>
        <div
          class="ui info message"
          style="display: inline-block"
          v-if="task_weighting_summation(stage) < 100"
        >
          <div class="header">
            {{ $t("weighting incomplete") }}
          </div>
          <p>
            {{ $t("weighting summation is incomplete, check tasks weighting") }}
          </p>
        </div>
      </generic-view> -->
    </div>
  </generic-view>
</template>

<script>
import GenericView from "@/components/GenericContainer";
import { cloneDeep } from "lodash";
import { v4 } from "uuid";
import Stage from "./Stage.vue";

export default {
  name: "CourseModalWeighting",
  props: {
    course_in: Object,
  },
  components: {
    "generic-view": GenericView,
    Stage,
  },
  data() {
    return {
      stages: [],
    };
  },
  computed: {
    stage_weighting_summation() {
      return this.stages.reduce((prev, curr) => {
        if (curr.extra == true) return prev;
        else return prev + Number(curr.weighting_percent);
      }, 0);
    },
  },
  methods: {
    add() {
      let vm = this;
      vm.stages.push({
        uuid: v4(),
        name: vm.$t("stage") + vm.stages.length,
        tasks: [],
        weighting_percent: 0,
        extra: false,
      });
    },
    getList() {
      return this.stages;
    },
    remove_stage(index) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove stage?"), function() {
        vm.stages.splice(index, 1);
      });
    },
  },
  mounted() {
    let vm = this;
    setTimeout(() => {
      if (vm.course_configuration && vm.course_configuration.weighting) {
        vm.stages = vm.course_configuration.weighting;
      }

      if (vm.course_in) {
        vm.stages = cloneDeep(vm.course_in.setup.weighting);
      }
    }, 300);
    // this.processing = true;
    // setTimeout(function() {
    //   local_api(vm, "post", "/customer_email/do-get-initial-items", {
    //     uuid: vm.$props.customer.uuid
    //   })
    //     .then(items => {
    //       vm.addresses = items;
    //       vm.all_addresses = clone(items);
    //       vm.processing = false;
    //     })
    //     .catch(err => {
    //       error_toast(err);
    //       console.error(err);
    //     });
    // }, 100);
  },
  watch: {
    stages() {
      let vm = this;
      setTimeout(() => {
        window.jQuery(".ui.slider").slider({
          min: 0,
          max: 100,
          start: 0,
          step: 5,
          onMove: function(value) {
            let stageIndex = window.jQuery(this).data("si");
            if (stageIndex >= 0)
              vm.stages[stageIndex].weighting_percent = value;
          },
        });
      }, 200);
    },
  },
};
</script>
